import { render, staticRenderFns } from "./DrawerTreatmentTab.vue?vue&type=template&id=62c3c770&scoped=true"
import script from "./DrawerTreatmentTab.vue?vue&type=script&lang=js"
export * from "./DrawerTreatmentTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerTreatmentTab.vue?vue&type=style&index=0&id=62c3c770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3c770",
  null
  
)

export default component.exports